export default class ResultFacilities {
    constructor(id, capacity, lat, long) {
      this.id = id;
      this.capacity = capacity;
      this.lat = lat;
      this.long=long;
    }
  }